import React, { ReactNode } from 'react';
import WarningIcon from '~/assets/icons/ontario-icon-alert-warning.svg';
import FormInlineError from './styles';
import styled from 'styled-components';
import sanitizeHtml from '~/utils/sanitize-html';

interface InlineErrorProps {
    id?: string;
    type?: string;
    children: ReactNode;
    className?: string;
}

const IconContainer = styled.div`
    svg {
        height: 20px;
        width: 20px;
    }
`;

const sanitizationConfigs = { FORCE_BODY: true, ALLOWED_ATTR: ['href', 'target', 'rel'] };

const InlineError = ({ id, children, className, type = 'error' }: InlineErrorProps) => {
    return (
        <FormInlineError id={id} role="alert" className={className} type={type}>
            <span>
                {type === 'warning' ? (
                    <IconContainer>
                        <WarningIcon aria-hidden="true" focusable="false" />
                    </IconContainer>
                ) : (
                    <svg
                        aria-hidden="true"
                        focusable="false"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="10" cy="10" r="10" fill="#BD261A" />
                        <path
                            d="M10.8438 11.6846H9.17578L8.82715 5.00586H11.1924L10.8438 11.6846ZM8.7998 14.0225C8.7998 13.6396 8.90234 13.3503 9.10742 13.1543C9.3125 12.9583 9.611 12.8604 10.0029 12.8604C10.3812 12.8604 10.6729 12.9606 10.8779 13.1611C11.0876 13.3617 11.1924 13.6488 11.1924 14.0225C11.1924 14.3825 11.0876 14.6673 10.8779 14.877C10.6683 15.082 10.3766 15.1846 10.0029 15.1846C9.62012 15.1846 9.32389 15.0843 9.11426 14.8838C8.90462 14.6787 8.7998 14.3916 8.7998 14.0225Z"
                            fill="white"
                        />
                    </svg>
                )}
            </span>
            {typeof children === 'string' ? (
                <span
                    /* eslint-disable-next-line react/no-danger */
                    dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(children, sanitizationConfigs),
                    }}
                />
            ) : (
                children
            )}
        </FormInlineError>
    );
};

export default InlineError;
